import MuiSnackbar, { type SnackbarProps as MuiSnackbarProps } from '@mui/material/Snackbar';
import Alert from '../primitives/Alert';
import type { SnackbarSeverity } from '@/shared/hooks/useSnackbar';

export type SnackbarProps = MuiSnackbarProps;

const Snackbar = (props: MuiSnackbarProps) => <MuiSnackbar {...props} />;

export default Snackbar;

export interface AppSnackbarProps {
  open: boolean;
  message: string;
  severity?: SnackbarSeverity;
  onClose: () => void;
  autoHideDuration?: number;
}

/** Standard app toast replacement: bottom-right snackbar with Alert. */
export function AppSnackbar({
  open,
  message,
  severity = 'success',
  onClose,
  autoHideDuration = 6000,
}: AppSnackbarProps) {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </MuiSnackbar>
  );
}
